import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import { Language } from './features/language/Language';
import * as serviceWorker from './serviceWorker';
import { Authentication } from './common/authentication';

import 'paper-kit-pro-react/theme/assets/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'paper-kit-pro-react/theme/assets/scss/paper-kit.scss';

// Import i18n messages
import { translationMessages } from './i18n';

if (
  !process.env.REACT_APP_TPICAP_ENV ||
  process.env.REACT_APP_TPICAP_ENV === 'development' ||
  process.env.REACT_APP_TPICAP_ENV === 'npd'
) {
  console.log(`Version: ${process.env.REACT_APP_GIT_SHA}`);
}

const render = (messages) => {
  ReactDOM.render(
    <React.StrictMode>
      <Authentication>
        <Provider store={store}>
          <Language messages={translationMessages}>
            <App />
          </Language>
        </Provider>
      </Authentication>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
